import yup from 'src/libraries/validator.library';

export const FooterSchema = yup.object({
  count: yup.number(),
  footer: yup.array().of(
    yup.object({
      FooterId: yup.string(),
      AppId: yup.string(),
      message: yup.string(),
      Application: yup.object({
        AppId: yup.string(),
        AppName: yup.string(),
        Company: yup.string(),
        IsActive: yup.boolean(),
      }),
    })
  ),
}).defined();

export const NotificationSchema = yup.object({
  count: yup.number(),
  notification: yup.array().of(
    yup.object({
      MessageId: yup.string(),
      AppId: yup.string(),
      MessageHeader: yup.string(),
      MessageBody: yup.string(),
      MessageType: yup.string(),
      StartTime: yup.string(),
      EndTime: yup.string(),
      CreatedDate: yup.string(),
      Status: yup.string(),
      Application: yup.object({
        AppId: yup.string(),
        AppName: yup.string(),
        Company: yup.string(),
        IsActive: yup.boolean(),
      })
    })
  ),
}).defined();

export type IFooter = yup.InferType<typeof FooterSchema>;
export type INotification = yup.InferType<typeof NotificationSchema>;
